import { useRef, useState } from "react";
import { toast } from "sonner";

export function useDictation(locale, onText) {
  const [active, setActive] = useState(false);
  const recog = useRef(null);
  const SR = typeof window !== "undefined" && (window.SpeechRecognition || window.webkitSpeechRecognition);

  const toggle = (base = "") => {
    if (active) {
      recog.current?.stop();
      return;
    }
    if (!SR) {
      toast.error("Dictation is not supported in this browser. Use push-to-talk instead.");
      return;
    }
    const r = new SR();
    r.lang = locale;
    r.interimResults = true;
    r.continuous = true;
    r.onresult = (e) => {
      const txt = Array.from(e.results).map((x) => x[0].transcript).join(" ");
      onText(`${base}${base ? " " : ""}${txt}`.trim());
    };
    r.onend = () => setActive(false);
    r.onerror = () => setActive(false);
    recog.current = r;
    r.start();
    setActive(true);
  };

  return { active, toggle, supported: !!SR };
}
